import { useEffect, useState } from 'react';
import { Modal } from '../components/Modal.js';
import { Icon } from '../components/Icon.js';

/** "Decline X?" with what follows, and the required reason (F10 P3). */
export function DeclineModal({
  open,
  title,
  lines,
  busy,
  onClose,
  onConfirm,
}: {
  open: boolean;
  title: string;
  lines: string[];
  busy?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}) {
  const [reason, setReason] = useState('');
  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} width={460}>
      <div style={{ padding: 22 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
          <div
            className="t-icon"
            style={{ background: 'var(--st-declined-soft)', color: 'var(--st-declined)' }}
          >
            <Icon name="x" size={16} />
          </div>
          <h3 style={{ margin: 0, fontSize: 16 }}>{title}</h3>
        </div>
        <div style={{ color: 'var(--text-2)', fontSize: 13, marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
          {lines.map((l) => (
            <p key={l} style={{ margin: 0 }}>
              {l}
            </p>
          ))}
        </div>
        <label className="field-label" htmlFor="decline-reason" style={{ marginTop: 16 }}>
          Reason for declining
        </label>
        <textarea
          id="decline-reason"
          className="textarea"
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="For example: couldn’t confirm the trading address"
          autoFocus
        />
        <div className="field-help">Saved in the activity and shown on the Teams card.</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 9, marginTop: 18 }}>
          <button className="btn" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button
            className="btn danger"
            disabled={!reason.trim() || busy}
            onClick={() => onConfirm(reason.trim())}
          >
            {busy ? 'Declining…' : 'Decline'}
          </button>
        </div>
      </div>
    </Modal>
  );
}
